import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Fires a GA4 + Google Ads `page_view` on every SPA route change.
 *
 * - The initial pageview is fired manually on mount so it works even if the
 *   first navigation happens before gtag.js finishes loading.
 * - `send_page_view: false` is set on BOTH configs (GA4 + Ads) in index.html
 *   so the auto-pageview never double-fires alongside this one.
 * - No `send_to` filter — events propagate to every configured destination
 *   (GA4 property + Ads account) for unified pageview + remarketing coverage.
 * - `gtag` is exposed on `window` from index.html; if blocked by an ad
 *   blocker we silently no-op.
 */
export default function RouteTracker() {
  const location = useLocation();

  useEffect(() => {
    if (typeof window === "undefined" || typeof window.gtag !== "function") return;
    const path = location.pathname + location.search;
    window.gtag("event", "page_view", {
      page_path: path,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [location.pathname, location.search]);

  return null;
}
